import { LoadingButton } from '@mui/lab'
import { Button, Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import JelledModal, { ModalButtonsContainerStack } from 'components/JelledModal'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

const BulkActionModal = ({
  content,
  isOpen,
  onClose,
  headerText,
  subtitleText,
  onSubmitClick,
  submitButtonText,
  isSubmitting,
}: {
  content: React.ReactNode // the content that is displayed in the body of the modal
  isOpen: boolean
  onClose: () => void
  headerText?: string
  subtitleText?: string
  onSubmitClick: () => void // the handler for when the user confirms an action
  submitButtonText: string // the text for the confirmation button
  isSubmitting: boolean
}) => {
  const isMobile = useCheckMobileScreen()

  return (
    <JelledModal
      onClose={onClose}
      isOpen={isOpen}
      width={isMobile ? '100%' : '960px'}
      modalStyle={{
        backgroundColor: COLORS.PURE_WHITE,
      }}>
      <Stack width={isMobile ? '100%' : '702px'} mb={4}>
        <Typography variant="h4" color="secondary">
          {headerText}
        </Typography>

        <Typography variant="pS">{subtitleText}</Typography>
      </Stack>

      {content}

      <ModalButtonsContainerStack>
        <Button onClick={onClose} size="medium" color="primary">
          Cancel
        </Button>
        <LoadingButton loading={isSubmitting} color="primary" variant="contained" size="medium" onClick={onSubmitClick}>
          {submitButtonText}
        </LoadingButton>
      </ModalButtonsContainerStack>
    </JelledModal>
  )
}

export default BulkActionModal
